<div mat-dialog-title class="title-row">
    <span>Reklamationen setzen</span>
    <button
        *ngIf="canCreateTierreklamation"
        mat-icon-button
        color="accent"
        (click)="openCreateTierreklamationDialog()"
        [disabled]="isCreating || isLoading"
        matTooltip="Tierreklamation anlegen"
    >
        <mat-icon>add</mat-icon>
    </button>
</div>

<mat-dialog-content class="dialog-content">
    <p>
        Es werden {{ data?.tiere?.length || 0 }} ausgewählte Tiere aktualisiert.
    </p>

    <div *ngIf="isLoading" class="loading-container">
        <mat-spinner diameter="32"></mat-spinner>
    </div>

    <mat-selection-list
        *ngIf="!isLoading"
        [multiple]="true"
        class="reklamationen-list"
        (selectionChange)="onSelectionChange($event)"
    >
        <mat-list-option
            *ngFor="let reklamation of reklamationen"
            [selected]="isChecked(reklamation)"
            [value]="reklamation"
        >
            {{ reklamation.reklamation }}
        </mat-list-option>
    </mat-selection-list>
</mat-dialog-content>

<mat-dialog-actions style="display: flex; justify-content: space-between; width: 100%">
    <button mat-flat-button color="primary" (click)="save()" [disabled]="isSaving || isLoading">
        <mat-spinner *ngIf="isSaving" diameter="20"></mat-spinner>
        <span *ngIf="!isSaving">Speichern</span>
    </button>
    <div style="display: flex; align-items: center; gap: 12px">
        <button mat-button color="warn" (click)="removeAll()" [disabled]="isSaving || isLoading">
            Alle entfernen
        </button>
        <button mat-button (click)="cancel()" [disabled]="isSaving">Abbrechen</button>
    </div>
</mat-dialog-actions>


